import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"

import { actions as appActions } from "../../modules/appModule"
import { actions as userActions } from "../../modules/userModule"

import Page, { Content } from "../../components/Page"
import DashboardNavbar from "../../components/layout/DashboardNavbar"
import Footer from "../../components/Footer"
import { ALERTS, COLOR, COMPANY_TYPE, FTSE_INDEX, INDEX_TIP, KEY_VALUES, NEWS_CATEGORY, NEWS_TIP, TYPE_TIP } from "../../modules/constants"

import FormGroup from '@mui/material/FormGroup'
import FormControlLabel from '@mui/material/FormControlLabel'
import Switch from '@mui/material/Switch'
import Checkbox from '@mui/material/Checkbox'
import Typography from "@mui/material/Typography"
import CircularProgress from '@mui/material/CircularProgress'

import Tooltip from '@mui/material/Tooltip'

class AlertsConfig extends Component {
  constructor(props) {
    // console.log("AlertsConfig constructor: props: ", props)
    props.user.getUserAlertsConfig()
    super()
  }

  render() {
    // console.log('AlertsConfig this.props:',this.props)

    const { userAlerts } = this.props
    // console.log('userAlerts :', userAlerts)

    const handleChange = event => {
      // console.log('event.target:', event.target)
      // console.log('event.target.id:', event.target.id)
      let userAlertsClone = JSON.parse(JSON.stringify(userAlerts))
      userAlertsClone[event.target.name] = event.target.checked
      this.props.user.setUserAlertsConfig(userAlertsClone)
    }

    const switchControl = ({ key }) => {
      // console.log('userNewsAlerts[key]:', userNewsAlerts[key]);
      return (
        <FormControlLabel
          style={{ marginLeft: 0, marginBottom: 30 }}
          checked={userAlerts[key]}
          name={key}
          control={<Switch />}
          label={<Typography style={{ fontSize: 20, fontWeight: "bold", marginRight: 30 }}>{key}</Typography>}
          onChange={handleChange}
          labelPlacement="start"
        />
      )
    }

    const mapObject = ({ disabled, obj, style, tip }) => Object.keys(obj).map((key, index) => (
      (typeof obj[key] !== "function" && <Tooltip
        key={index}
        title={tip[key]}
        placement="top"
        disableFocusListener
        enterDelay={KEY_VALUES.TOOLTIP_DELAY}
      >
        <FormControlLabel
          style={style}
          control={
            <Checkbox
              disabled={disabled}
              checked={userAlerts[obj[key]]}
              onChange={handleChange}
              name={obj[key]}
              style={style}
              id={`${obj.getName()}.${key}`}
            />}
          key={index}
          label={obj[key]}
        />
      </Tooltip>)
    ))

    // Should this be <FormGroup> or <FormControl> ?
    const checkboxFormGroup = ({ obj, title, tip }) => {
      const disabled = !userAlerts[ALERTS.NEWS]
      const style = { color: disabled ? COLOR.DISABLED : getColor(obj) }
      return (
        <React.Fragment>
          <br />
          <div style={{ ...style, fontWeight: "bold" }} >
            {title}
            <FormGroup className={"checkbox"} >
              {mapObject({
                disabled,
                obj,
                style,
                tip,
              })}
            </FormGroup>
          </div>
        </React.Fragment>
      )
    }

    // Return true if all alerts in group (eg NEWS_CATEGORY) are set to false
    const configAllFalse = obj => Object.keys(obj).every(id => userAlerts[obj[id]] == false)

    // Return COLOR.BAD if all NEWS_CATEGORY and all FTSE_INDEX are unchecked (false)
    const getColor = obj => configAllFalse(obj)
      ? COLOR.BAD
      : COLOR.BLACK

    return (
      <React.Fragment>
        <DashboardNavbar backLink portrait={this.props.portrait} />

        <Page>
          {userAlerts && <Content scroll>
            <div className="form-page">
              <div className="form-cell">
                <div className="form-wrapper" style={{ width: 350 }}>
                  {switchControl({ key: ALERTS.NEWS })}
                  {checkboxFormGroup({ obj: NEWS_CATEGORY, title: ALERTS.CATEGORY_INTRO, tip: NEWS_TIP })}
                  {checkboxFormGroup({ obj: FTSE_INDEX, title: ALERTS.NEWS_INTRO, tip: INDEX_TIP })}
                  {checkboxFormGroup({ obj: COMPANY_TYPE, title: ALERTS.TYPE_INTRO, tip: TYPE_TIP })}
                </div>
              </div>
            </div>
          </Content>}
        </Page >
        <Footer urlSource={this.props.urlSource} />

        {/* Show spinner during import of userAlerts i.e. while userAlerts is null */}
        {!userAlerts && <CircularProgress
          style={{ position: "fixed", top: "calc(50% - 20px)", left: "calc(50% - 20px)", zIndex: 2 }}
        />}
      </React.Fragment >
    )
  }
}

const mapStateToProps = ({ app, common, user }) => {
  return {
    // app
    features: app.features,
    rollups: app.rollups,

    // common
    urlSource: common.urlSource,

    // user
    portrait: user.portrait,
    userAlerts: user.userAlerts,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    app: bindActionCreators(appActions, dispatch),
    user: bindActionCreators(userActions, dispatch),
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(AlertsConfig)

